// extracted by mini-css-extract-plugin
export default {"overlayWrap":"Overlay_overlayWrap__XcC1c","overlay":"Overlay_overlay__U7ZBy","overlayBg":"Overlay_overlayBg__wA1lF","overlayContainer":"Overlay_overlayContainer__YlFsk"};